/**
 * Confirms availability of the Fullscreen API for an Element.
 * At the moment such feature isn't available on iOS (any browser), so a fake fullscreen workaround is necessary.
 */
export function isFullscreenAPIAvailableForElements() {
  return Element.prototype.requestFullscreen;
}
